import { ActivityLogEntityType } from '../api/model/activityLog';
import { getDocumentEditorGlobalWindowObject } from './AppUtils';

export const initialiseGlobalEditedSections = (): void => {
  getDocumentEditorGlobalWindowObject().activityLogTracking = {
    editedDocumentSections: new Set<number>(),
    editedChangeControlSections: new Set<number>(),
    changedDocumentRoots: new Set<string>(),
  };
};

export const addSectionToEditedSectionsList = (
  editedSectionId: number,
  entityType: ActivityLogEntityType,
): boolean => {
  let editedSections;
  switch (entityType) {
    case 'change_control':
      editedSections =
        getDocumentEditorGlobalWindowObject().activityLogTracking
          .editedChangeControlSections;
      break;
    case 'document':
    default:
      editedSections =
        getDocumentEditorGlobalWindowObject().activityLogTracking
          .editedDocumentSections;
      break;
  }

  if (!editedSections.has(editedSectionId)) {
    editedSections.add(editedSectionId);
    return true;
  }
  return false;
};

export const addRootToChangedRootsList = (rootName: string): void => {
  getDocumentEditorGlobalWindowObject().activityLogTracking.changedDocumentRoots.add(
    rootName,
  );
};

export const snapshotChangedDocumentRoots = (): Set<string> => {
  return new Set(
    getDocumentEditorGlobalWindowObject().activityLogTracking.changedDocumentRoots,
  );
};

export const clearChangedDocumentRoots = (toClear: Set<string>): void => {
  const tracked =
    getDocumentEditorGlobalWindowObject().activityLogTracking
      .changedDocumentRoots;
  for (const root of toClear) {
    tracked.delete(root);
  }
};
